/** Supplier accounts work within customer allocations until their role changes. */
export function isSupplierRole(role: number | undefined): boolean {
  return role === 5;
}

export function isBillingManagerRole(role: number | undefined): boolean {
  return role === 1 || isSupplierRole(role);
}

export function workspaceHomePath(role: number | undefined): string {
  if (role === 7) return "/log/emissions";
  return isSupplierRole(role) ? "/partners/customers" : "/home";
}

/** This workspace restriction complements the existing RBAC checks. */
export function supplierCanAccessPath(
  role: number | undefined,
  destination: string,
): boolean {
  if (!isSupplierRole(role)) return true;
  const path = destination.split(/[?#]/, 1)[0].replace(/\/+$/, "");
  return (
    path === "/partners/customers" ||
    path.startsWith("/partners/customers/") ||
    [
      "/resourcecentre",
      "/settings",
      "/settings/organisationInformation",
      "/settings/security",
      "/settings/transfer-account",
      "/settings/subscription",
    ].includes(path)
  );
}
